export const comparePaths = (
  path1: readonly number[],
  path2: readonly number[],
): number => {
  if (!path1.length && !path2.length) {
    return 0;
  }
  if (!path1.length) {
    return -1;
  }
  if (!path2.length) {
    return 1;
  }
  const [path1First] = path1;
  const [path2First] = path2;
  if ((path1First ?? -1) < (path2First ?? -1)) {
    return -1;
  }
  if ((path1First ?? -1) > (path2First ?? -1)) {
    return 1;
  }
  return comparePaths(path1.slice(1), path2.slice(1));
};
